<template>
  <!--This component should be wrapped in a relative container-->
  <div :style="`position: relative;float: left;width: 100%;height:${boxHeight}px;`">
    <div id="drag_drop_outer_box" ref="drag_drop_outer_box" :style="`height:${boxHeight}px;min-height:1px;width: 100%;position:absolute;`">
      <div id="one-px-div" style="height: 1px;width: 100%;"></div>
      <!--Background-->
      <vue-drag-resize ref="bg_container" :parentLimitation="true" :isActive="false" :preventActiveBehavior="true"
        :isResizable="false" :isDraggable="false" :w="bgDimensions.bg1.width" :style="`height:${bgDimensions.bg1.height}`"
        :x="bgDimensions.bg1.x" :y="bgDimensions.bg1.y">
        <img ref="background_image" :src="bg1_url" :width="bgDimensions.bg1.width" :height="bgDimensions.bg1.height" />
      </vue-drag-resize>

      <!--Background 1-->
      <vue-drag-resize v-if="drag_drop.background1" ref="bg1_container" :parentLimitation="true" :isActive="false"
        :preventActiveBehavior="true" :isResizable="false" :isDraggable="false" :w="bgDimensions.bg2.width"
        :style="`height:${bgDimensions.bg2.height}`" :x="bgDimensions.bg2.x" :y="bgDimensions.bg2.y">
        <show-image ref="background_image1" class="btn-center" :src="drag_drop.background1.file"
          :width="bgDimensions.bg2.width" :height="bgDimensions.bg2.height" />
      </vue-drag-resize>

      <!--Cliparts-->
      <vue-drag-resize v-for="(object, object_index) in objects" :key="`OBJECT_CLIPART_${object_index}`"
        :parentLimitation="true" :isActive="true" :isResizable="false" :isDraggable="true" :x="object.x" :y="object.y"
        :w="90" :h="90"
        @dragging="dragObject({ index: object_index, col_index: object.col_index, layer_index: object.layer_index }, $event)">

        <show-image :src="object.file" />
      </vue-drag-resize>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import ShowImage from "@/components/General/ShowImage";
const { getImageURL } = require("@/components/General/utils")
export default {
  name: "show-drag-drop",
  refs: ['drag_drop_outer_box'],
  components: {
    ShowImage
  },
  props: {
    drag_drop: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      objects: [],
      bg_img: {
        width: 0.1,
        height: 0.1
      },
      clipart_height: 200,
      bg1_url: ""
    };
  },
  computed: {
    ...mapGetters(["getTeacherToken"]),
    parentDimensions() {
      //Dimensions for each background -> Assumption is that first image should have max height
      let width = 0.1, height = 0.1 //Cannot give zero as this vue-drag-resize library needs greater than zero width and height
      if (this.$refs.drag_drop_outer_box && this.$refs.background_image) {

        width = this.$refs.drag_drop_outer_box.clientWidth // Width of outer container
        const img_factor = this.bg_img.width / this.bg_img.height // The scale factor of first img (We wont use second img)
        // Calculating the height of the container, i.e., height = width/img_factor
        height = width / img_factor

        if (this.drag_drop.background && this.drag_drop.background1) {
          //If both present then width & height = 50%
          width = width / 2
          height = height / 2
        }
      }
      return {
        width, height
      }
    },
    bgDimensions() {
      let width = this.parentDimensions.width
      let height = this.parentDimensions.height
      const dimensions = {
        bg1: {
          width,
          height,
          x: 0,
          y: 0
        },
        bg2: {
          width,
          height,
          x: width,
          y: 0
        },
      }
      return dimensions
    },
    boxHeight() {
      return this.parentDimensions.height + this.clipart_height //Adding 200 pixels (100 for each clipart layer)
    },
    layerType() {
      let type = 1 //default type
      if ((this.drag_drop.layers.length == 1) && (this.drag_drop.layers[0].number > 5)) {
        type = 2
      }
      return type
    }
  },
  methods: {
    ...mapActions(["updateCurrentAnswer"]),
    dragObject(props, obj) {
      let object = Object.assign({}, this.objects[props.index])
      object.x = obj.left
      object.y = obj.top
      this.$set(this.objects, props.index, object)
    }
  },
  watch: {
    objects: function () {
      let is_correct = true
      //Checking if the layers allowed in the background are correct
      for (let layer_index in this.drag_drop.layers) {
        const layer = this.drag_drop.layers[layer_index]
        //Checking if the no of drag allowed is equal to dragged boxes
        const objects_this_layer = this.objects.filter(object => {
          const object_bg = object.background_drag
          const bg_drop_key = (object_bg == 'BG2') ? 'bg2' : 'bg1'
          return ((object.layer_index == layer_index) && (parseInt(object.y) < this.bgDimensions[bg_drop_key].height) && ((parseInt(object.y) + 90) < this.bgDimensions[bg_drop_key].height) && (parseInt(object.x) < (this.bgDimensions[bg_drop_key].x + this.bgDimensions[bg_drop_key].width)))
        })

        if (objects_this_layer.length != layer.number_drag) {
          is_correct = false
        }
      }

      this.updateCurrentAnswer({
        key: "drag_drop",
        value: is_correct
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      const img = this.$refs.background_image
      img.onload = () => {
        this.bg_img.width = img.naturalWidth
        this.bg_img.height = img.naturalHeight

        let objects = []

        let width = this.parentDimensions.width
        if (this.drag_drop.background && this.drag_drop.background1) {
          width = width * 2
        }
        let x_increment = width / 5

        for (let layer_index in this.drag_drop.layers) {
          const layer = this.drag_drop.layers[layer_index]

          //Finding y coordinate
          let y = this.parentDimensions.height + (parseInt(layer_index) * 95) + 5 //plus 5 extra so that it doesnt overlap
          let x = 0
          for (let i = 0; i < layer.number; i++) {
            if ((this.layerType == 2) && (i == 5)) {
              y = y + 95
              x = 0
            }
            objects.push({
              layer_index,
              col_index: i,
              file: layer.clipart.file,
              background_drag: layer.background_drag,
              x,
              y
            })

            x += x_increment
          }
        }
        this.objects = objects
      }
    })
  },
  created() {
    this.bg1_url = getImageURL(this.drag_drop.background.file)
  }
};
</script>
<style scoped>
.input {
  border-color: #6f6f6f !important;
}

.vdr.active:before {
  outline: none !important;
}
</style>